import { gql } from '@apollo/client';
import {
  AlertDescription,
  AlertTitle,
  Box,
  chakra,
  HStack,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
} from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import BackToAllActionsButton from '~components/displays/BulkAction/BackToAllActionsButton';
import { useManagePlaylistForm } from '~components/displays/useManagePlaylistForm';
import { InfoAlert, WarningAlert } from '~components/ui/Alert';
import { ModalCloseButton } from '~components/ui/ModalCloseButton';
import { BulkActionComponent } from './BulkActionModal';

export const BulkManagePlaylist: BulkActionComponent = ({
  displays,
  customer,
  onCancel,
  onBack,
  onSuccess,
  hasMultiplePlaylistTypes,
}) => {
  const playlistNotSupported = displays.filter((d) => !d.playlist);
  const playlistNotSupportedCount = playlistNotSupported.length;
  const playlistNotSupportedAlias =
    playlistNotSupportedCount === 1 ? playlistNotSupported[0].alias : null;
  const { body, footer, onSubmit } = useManagePlaylistForm({
    displays: displays.map((d) => ({
      id: d.id,
      ...(d.playlistType ? { playlistType: d.playlistType } : {}),
    })),
    customer,
    onCancel: onCancel,
    onSuccess: onSuccess,
    hasMultiplePlaylistTypes,
    playlistNotSupportedCount,
  });
  const { t } = useTranslation();
  return (
    <>
      <ModalContent>
        <ModalHeader>{t('manageplaylist')}</ModalHeader>
        <ModalCloseButton onClick={onCancel} />
        <form onSubmit={onSubmit}>
          {hasMultiplePlaylistTypes && (
            <Box px="7" py="8">
              <WarningAlert>
                <AlertTitle>{t('incompatiblePlaylist')}</AlertTitle>
                <AlertDescription>{t('incompatiblePlaylistDesc')}</AlertDescription>
              </WarningAlert>
            </Box>
          )}
          {playlistNotSupportedCount > 0 && (
            <Box px="7" py="8">
              <WarningAlert>
                <AlertDescription>
                  {' '}
                  <Trans
                    i18nKey="playlistNotSupported"
                    count={playlistNotSupportedCount}
                    values={{
                      name: playlistNotSupportedAlias,
                      count: playlistNotSupportedCount,
                    }}
                    components={{
                      strong: <chakra.strong />,
                    }}
                  />
                </AlertDescription>
              </WarningAlert>
            </Box>
          )}
          {!hasMultiplePlaylistTypes && playlistNotSupportedCount == 0 && (
            <ModalBody>
              <Stack spacing="4">
                <InfoAlert>{t('playlistSyncAlert')}</InfoAlert>
                {body}
              </Stack>
            </ModalBody>
          )}
          <ModalFooter>
            <HStack flex="1" justifyContent="space-between">
              <BackToAllActionsButton onBack={onBack} />
              <Box>{footer}</Box>
            </HStack>
          </ModalFooter>
        </form>
      </ModalContent>
    </>
  );
};

BulkManagePlaylist.graphql = {
  fragments: {
    BulkManagePlaylist_customer: gql`
      fragment BulkManagePlaylist_customer on Customer {
        id
        ...useManagePlaylistForm_customer
      }
    `,
  },
};
